// User blocking persisted in Lovable Cloud (`public.user_blocks`).
// A user can only ever create / read / delete their OWN blocks (enforced by RLS).

import { supabase } from '@/integrations/supabase/client';

export async function fetchBlockedIds(userId: string): Promise<string[]> {
  const { data, error } = await supabase
    .from('user_blocks')
    .select('blocked_id')
    .eq('blocker_id', userId);
  if (error) {
    console.warn('[blocks] fetch failed', error);
    return [];
  }
  return (data ?? []).map((row) => row.blocked_id);
}

export async function blockUser(blockerId: string, blockedId: string): Promise<{ error?: string }> {
  const { error } = await supabase
    .from('user_blocks')
    .insert({ blocker_id: blockerId, blocked_id: blockedId });
  // Unique violation = already blocked, treat as success.
  if (error && error.code !== '23505') return { error: error.message };
  return {};
}

export async function unblockUser(blockerId: string, blockedId: string): Promise<{ error?: string }> {
  const { error } = await supabase
    .from('user_blocks')
    .delete()
    .eq('blocker_id', blockerId)
    .eq('blocked_id', blockedId);
  return { error: error?.message };
}
